/* =====================================
*  商品ページのJS定義
* ===================================== */





// メタフィールドの開閉を制御
document.addEventListener("DOMContentLoaded", function() {
  var accordions = document.querySelectorAll(".product__meta--dropdawn dt");
  accordions.forEach(function(accordion) {
    accordion.addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  });
});